import { render, staticRenderFns } from "./our-people.vue?vue&type=template&id=0b27e6dc&scoped=true&"
import script from "./our-people.vue?vue&type=script&lang=js&"
export * from "./our-people.vue?vue&type=script&lang=js&"
import style0 from "./our-people.vue?vue&type=style&index=0&id=0b27e6dc&scoped=true&lang=css&"
import style1 from "./our-people.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27e6dc",
  null
  
)

export default component.exports